import { PermissionModel } from './permission.model';
import { RoleModel } from './role.model';

export class ScopeModel {
  roles: RoleModel[] = [];
  permissions: PermissionModel[] = [];
}
